import yousers from '@yola/yousersjs';
import store from 'src/js/store';
import config from 'src/js/modules/config';

const configureYousersJS = () => {
  const state = store.getState();
  const apiURL = config.selectors.getApiUrl(state);
  const oauthURL = config.selectors.getInitiateOauthUrl(state);

  yousers.setOAuthUrl(oauthURL);
  yousers.setAPIRoot(apiURL);
};

export default configureYousersJS;
